export const StorageLandingPageTemplate = {
    slots: ['SlbCheckoutContainerSlot'],
};